import React from 'react';

const inputBaseClass = 'h-11 w-full rounded-xl border border-slate-300 bg-white px-3 text-sm text-slate-800 outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-100 disabled:bg-slate-100 disabled:text-slate-500';
const errorClass = 'border-rose-400 focus:border-rose-400 focus:ring-rose-100';

export const TextInput = ({ className = '', ...props }) => (
  <input {...props} className={`${inputBaseClass} ${className}`.trim()} />
);

export const NumberInput = ({ className = '', ...props }) => (
  <input {...props} type="number" step={props.step || '0.01'} className={`${inputBaseClass} text-right [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${className}`.trim()} />
);

export const DateInput = ({ className = '', ...props }) => (
  <input {...props} type="date" className={`${inputBaseClass} pr-3 ${className}`.trim()} />
);

export const TextAreaInput = ({ className = '', ...props }) => (
  <textarea {...props} className={`w-full rounded-xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-800 outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-100 disabled:bg-slate-100 disabled:text-slate-500 ${className}`.trim()} />
);

export const errorClassName = errorClass;

const Inputs = {
  TextInput,
  NumberInput,
  DateInput,
  TextAreaInput,
  errorClassName
};
export default Inputs;
